import { Text, Tooltip } from "@mantine/core";
import {
  formatDateTimeInTz,
  formatDateTimeTriple,
  formatTimezoneShort,
  getViewerTimezone,
} from "@mip-tg-bot-turntable/utils";

type Props = {
  readonly iso: string | null | undefined;
  readonly businessTimezone: string;
  readonly size?: "xs" | "sm";
  readonly fallback?: string;
};

/**
 * 列表时间：默认业务时区；Tooltip 给业务 / 本地 / UTC 三对照。
 */
export function BusinessDateTime(props: Props) {
  const { iso, businessTimezone, size = "xs", fallback = "-" } = props;
  if (iso === null || iso === undefined || iso === "") {
    return (
      <Text size={size} c="dimmed">
        {fallback}
      </Text>
    );
  }
  const viewerTz = getViewerTimezone();
  const triple = formatDateTimeTriple(iso, businessTimezone, viewerTz);
  const bizShort = formatTimezoneShort(businessTimezone);
  const label = (
    <div>
      <div>
        业务 ({bizShort}): {triple.business}
      </div>
      <div>本地: {triple.viewer}</div>
      <div>{triple.utc}</div>
    </div>
  );
  return (
    <Tooltip label={label} multiline maw={320} withArrow openDelay={200}>
      <Text size={size} c="dimmed" ff="monospace" style={{ cursor: "help", whiteSpace: "nowrap" }}>
        {formatDateTimeInTz(iso, businessTimezone)}
        <Text span size="xs" c="dimmed" ml={4}>
          {bizShort}
        </Text>
      </Text>
    </Tooltip>
  );
}
